import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { CreateWorkRequestParams } from '@/features/work/api/create-work-request/request';
import { createWorkRequest } from '@/features/work/api/create-work-request/request';

export const useCreateWorkRequestMutation = (
  settings?: MutationSettings<CreateWorkRequestParams, typeof createWorkRequest>
) =>
  useMutation({
    mutationKey: ['CreateWorkRequest'],
    mutationFn: ({ params, config }) =>
      createWorkRequest({
        params,
        config
      }),
    ...settings?.options
  });
